import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Competencies from "../components/sections/Competencies";
import Projects from "../components/sections/Projects";
import Experience from "../components/sections/Experience";
import Skills from "../components/sections/Skills";
import Contact from "../components/sections/Contact";
import Marquee from "../components/sections/Marquee";

export default function Portfolio() {
  return (
    <main
      data-testid="portfolio-page"
      className="relative min-h-screen bg-[#0A0A0A] text-[#F5F5F5] font-display accent-glow"
    >
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Competencies />
      <Projects />
      <Experience />
      <Skills />
      <Contact />
    </main>
  );
}
